export default "__VITE_ASSET__CuICE3vc__"